<script setup lang="ts">
defineProps<{ id: string; messages: string[] }>()
</script>

<template>
  <p v-if="messages.length" :id="id" class="field-warning">{{ messages.join(' ') }}</p>
</template>
